import { Button, Inline } from '@omnipresentgroup/design-system';
import { useInvoiceReportEmployees } from '@omnipresentgroup/domains';
import { useMemo } from 'react';
import { useNavigate } from 'react-router';

import { INVOICE_EMPLOYEE_DETAILS_PATH } from '../../../../constants';

type Props = {
  companyId: string;
  invoiceId: string;
  currentEmployeeId: string;
  onNavigate?: () => void;
};

export const InvoiceReportEmployeeNavigation = ({
  companyId,
  invoiceId,
  currentEmployeeId,
  onNavigate,
}: Props) => {
  const navigate = useNavigate();

  const { data: employees, isLoading: isEmployeesLoading } =
    useInvoiceReportEmployees({
      invoiceId: invoiceId || '',
      companyId: companyId,
      enabled: !!companyId && !!invoiceId,
    });

  const currentEmployeeIndex = useMemo(
    () => employees?.data.findIndex((emp) => emp.id === currentEmployeeId) || 0,
    [currentEmployeeId, employees],
  );

  const previousEmployeeId = useMemo(
    () => employees?.data[currentEmployeeIndex - 1]?.id,
    [currentEmployeeIndex, employees?.data],
  );

  const nextEmployeeId = useMemo(
    () => employees?.data[currentEmployeeIndex + 1]?.id,
    [currentEmployeeIndex, employees?.data],
  );

  return (
    <Inline gap="16" align="center" css={{ flexWrap: 'wrap' }}>
      <Button
        variant="secondary"
        disabled={!previousEmployeeId || isEmployeesLoading}
        onClick={() => {
          onNavigate?.();
          previousEmployeeId &&
            navigate(
              INVOICE_EMPLOYEE_DETAILS_PATH(invoiceId, previousEmployeeId),
            );
        }}
      >
        Previous employee
      </Button>
      <Button
        variant="primary"
        disabled={!nextEmployeeId || isEmployeesLoading}
        onClick={() => {
          onNavigate?.();
          nextEmployeeId &&
            navigate(INVOICE_EMPLOYEE_DETAILS_PATH(invoiceId, nextEmployeeId));
        }}
      >
        Next employee
      </Button>
    </Inline>
  );
};
